<p-dialog [(visible)]="displayDialog" [style]="{ width: '50vw' }" [modal]="true" [draggable]="false" [resizable]="false"
    [closable]="true" (onHide)="onDialogClosed()" [header]="esEdicion ? 'Editar Opción' : 'Nueva Opción'">
    <form [formGroup]="form" (ngSubmit)="onSubmit()" appPermissionControl="P273F0001">
        <div class="form-row">
            <div class="form-field">
                <input pInputText type="text" formControlName="sClaveCues" class="form-control"
                    [placeholder]="cuestionario?.sClaveCues" disabled appPermissionControl="P273K0001">
                <label>Clave Cuestionario</label>
            </div>
            <div class="form-field">
                <input pInputText type="number" formControlName="iNumPreg" class="form-control"
                    [placeholder]="preguntaSeleccionada?.iNumPreg" disabled appPermissionControl="P273K0002">
                <label>N° Pregunta</label>
            </div>
        </div>

        <div class="form-row">
            <div class="form-field">
                <input pInputText type="number" formControlName="iNumOpcion" class="form-control"
                    placeholder="N° Opción" [disabled]="esEdicion" appPermissionControl="P273K0003">
                <label>N° Opción</label>
            </div>
            <div class="form-field">
                <input pInputText type="text" formControlName="sValorStr" class="form-control"
                    placeholder="Valor" appPermissionControl="P273K0004">
                <label>Valor</label>
            </div>
        </div>

        <div class="form-row">
            <div class="form-field">
                <input pInputText type="number" formControlName="dRango1" class="form-control"
                    placeholder="Rango 1" appPermissionControl="P273K0005">
                <label>Rango 1</label>
            </div>
            <div class="form-field">
                <input pInputText type="number" formControlName="dRango2" class="form-control"
                    placeholder="Rango 2" appPermissionControl="P273K0006">
                <label>Rango 2</label>
            </div>
        </div>

        <div class="form-row">
            <div class="form-field">
                <input pInputText type="number" formControlName="iScore" class="form-control"
                    placeholder="Score" appPermissionControl="P273K0007">
                <label>Score</label>
            </div>
            <div class="form-field">
                <input pInputText type="number" formControlName="iSigPreg" class="form-control"
                    placeholder="Sig. Pregunta" appPermissionControl="P273K0008">
                <label>Sig. Pregunta</label>
            </div>
        </div>

        <div class="button-section mt-3">
            <button mat-flat-button class="btn-success btn-menu" type="submit" [disabled]="!form.valid || loading" appPermissionControl="P273B0001">
                <mat-icon *ngIf="!loading">save</mat-icon>
                <p-progressSpinner *ngIf="loading" styleClass="w-4rem h-4rem" strokeWidth="8"
                    fill="var(--surface-ground)" animationDuration=".5s"></p-progressSpinner>
                {{ esEdicion ? 'Actualizar' : 'Guardar' }}
            </button>
            <ng-container *ngIf="esEdicion">
                <button mat-flat-button class="btn-search btn-menu" type="button" (click)="openScriptDialog()" appPermissionControl="P273B0002">
                    <mat-icon>description</mat-icon>
                    Script
                </button>
            </ng-container>
        </div>
    </form>
</p-dialog>

<p-toast position="bottom-right"></p-toast>

<app-script-dialog
    [(displayDialog)]="displayScriptDialog"
    [cuestionario]="cuestionario"
    [preguntaSeleccionada]="preguntaSeleccionada"
    [opcionSeleccionada]="opcionSeleccionada"
    (onHide)="onScriptDialogClosed($event)">
</app-script-dialog> 